type AnyObject = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function pluck(path: string, obj: AnyObject | any): any {
  const keys = path.split(".");

  let current = obj;

  for (const k of keys) {
    const key = Number.isInteger(+k) ? +k : k;

    if (!current[key]) {
      return undefined;
    }

    current = current[key];
  }

  return current;
}
